// storeFormSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NameLang {
  languageCode: string;
  name: string;
}

interface OpeningHour {
  day: string;
  openTime: string | null;
  closeTime: string | null;
}

interface PickupMethods {
  in_store: boolean;
  drive_thru: boolean;
}

interface StoreFormState {
  commercialRegister: string | null;
  taxNumber: string | null;
  city: string;
  name: NameLang[];
  phone: string;
  lat: number | null;
  lng: number | null;
  subTypeId: number | null;
  sectorId: number | null;
  type: number | null;
  pickupMethods: PickupMethods;
  openingHours: OpeningHour[];
  logo: File | null;
  commercialRegisterFile: File | null;
  taxNumberFile: File | null;
  coverImage: File | null;
  phoneLogin: string;
  password: string;
}

const initialState: StoreFormState = {
  commercialRegister: "",
  taxNumber: "",
  city: "",
  name: [],
  phone: "",
  lat: null,
  lng: null,
  subTypeId: null,
  sectorId: null,
  type: null,
  pickupMethods: { in_store: false, drive_thru: false },
  openingHours: [
    { day: "sun", openTime: "", closeTime: "" },
    { day: "mon", openTime: "", closeTime: "" },
    { day: "tue", openTime: "", closeTime: "" },
    { day: "wed", openTime: "", closeTime: "" },
    { day: "thu", openTime: "", closeTime: "" },
    { day: "fri", openTime: "", closeTime: "" },
    { day: "sat", openTime: "", closeTime: "" },
  ],
  logo: null,
  coverImage: null,
  taxNumberFile: null,
  commercialRegisterFile: null,
  phoneLogin: "",
  password: "",
};

const storeFormSlice = createSlice({
  name: "storeForm",
  initialState,
  reducers: {
    updateForm(state, action: PayloadAction<Partial<StoreFormState>>) {
      return { ...state, ...action.payload };
    },
    resetForm() {
      return initialState;
    },
  },
});

export const { updateForm, resetForm } = storeFormSlice.actions;
export default storeFormSlice.reducer;
